import { render, staticRenderFns } from "./aboutNount.vue?vue&type=template&id=15035397"
import script from "./aboutNount.vue?vue&type=script&lang=js"
export * from "./aboutNount.vue?vue&type=script&lang=js"
import style0 from "./aboutNount.vue?vue&type=style&index=0&id=15035397&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports